import { PAGE_TYPE_ORDERS_LIST, PAGE_TYPE_DETAIL } from "../constants.js";

/**
 * Determines based on path whether to display order list or order detail page
 * @param {string} path
 * @returns {{
 *  type: PAGE_TYPE_DETAIL | PAGE_TYPE_ORDERS_LIST,
 *  id: number | undefined
 * }} What page to display
 */
export const getDisplayType = (path) => {
  const pathArray = path.split("/");
  if (pathArray.length === 3 && pathArray[1] === PAGE_TYPE_DETAIL && Number.isInteger(Number(pathArray[2]))) {
    return { type: PAGE_TYPE_DETAIL, id: Number(pathArray[2]) };
  } else if (
    (pathArray.length === 1 && pathArray[0] === "") ||
    (pathArray.length === 2 && pathArray[1] === PAGE_TYPE_ORDERS_LIST)
  ) {
    return { type: PAGE_TYPE_ORDERS_LIST };
  } else {
    return { type: null };
  }
};
